import React from "react";
import { CheckCircle2, Truck, Wrench, PhoneCall, MessageCircle, ShieldCheck, FileCheck2, Award } from "lucide-react";
import { company, heroBg, heroBadges, trustBadges } from "../mock";
import { usePreventivo } from "./PreventivoContext";

const iconMap = { CheckCircle2, Truck, Wrench, PhoneCall, ShieldCheck, FileCheck2, Award };

const Hero = () => {
  const { openPreventivo } = usePreventivo();
  return (
    <section className="relative">
      {/* Hero */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${heroBg})` }} />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f2846]/95 via-[#0f2846]/85 to-[#0f2846]/70" />
        <div className="relative max-w-7xl mx-auto px-4 py-20 md:py-28">
          <div className="max-w-3xl reveal">
            <span className="inline-block bg-white/10 border border-white/20 text-white/90 text-sm font-medium px-4 py-1.5 rounded-full backdrop-blur-sm">
              {company.since} · {company.soldLabel}
            </span>
            <h1 className="font-display text-white text-4xl md:text-6xl font-bold mt-6 leading-[1.1]">
              Motori Usati e Rettificati <span className="text-[#ff5a5e]">Garantiti</span>
            </h1>
            <p className="font-display text-white/70 text-xl md:text-2xl mt-3">— Tutte le marche</p>
            <p className="text-white/80 text-base md:text-lg mt-6 leading-relaxed">
              Vendiamo motori usati, rettificati, revisionati e rigenerati per <b className="text-white">auto di tutte le marche</b>. <b className="text-white">16 anni di esperienza</b>, <b className="text-white">1.000+ motori venduti</b>, garanzia 12-24 mesi, spedizione <b className="text-white">GRATUITA</b> in tutta Italia.
            </p>
            <div className="flex flex-wrap gap-x-6 gap-y-2 mt-6">
              {heroBadges.map((b, i) => {
                const Ic = iconMap[b.icon];
                return (
                  <span key={i} className="flex items-center gap-2 text-white/90 text-sm font-medium">
                    <Ic size={17} className="text-[#22c35e]" /> {b.text}
                  </span>
                );
              })}
            </div>
            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <button onClick={() => openPreventivo()} className="inline-flex items-center justify-center bg-[#e8464a] hover:bg-[#d43a3e] text-white font-semibold px-7 py-3.5 rounded-lg transition-all hover:-translate-y-0.5 shadow-lg shadow-[#e8464a]/30">
                Richiedi preventivo gratuito
              </button>
              <a href={company.whatsappLink} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-2 bg-[#22c35e] hover:bg-[#1da851] text-white font-semibold px-7 py-3.5 rounded-lg transition-all hover:-translate-y-0.5 shadow-lg shadow-[#22c35e]/30">
                <MessageCircle size={18} /> WhatsApp {company.whatsappDisplay}
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Red guarantee strip */}
      <div className="bg-[#e8464a] text-white">
        <div className="max-w-7xl mx-auto px-4 py-5 flex items-center justify-center gap-4 text-center">
          <ShieldCheck size={30} className="shrink-0" />
          <div>
            <div className="font-display font-bold text-lg">Garanzia 24 mesi</div>
            <div className="text-white/85 text-sm">Inclusa su tutti i motori rettificati e rigenerati</div>
          </div>
          <ShieldCheck size={30} className="shrink-0 hidden sm:block" />
        </div>
      </div>

      {/* Trust badges */}
      <div className="bg-white border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 py-8 grid grid-cols-2 md:grid-cols-4 gap-6">
          {trustBadges.map((b, i) => {
            const Ic = iconMap[b.icon];
            return (
              <div key={i} className="flex flex-col items-center text-center gap-2">
                <div className="w-12 h-12 rounded-full bg-slate-50 border border-slate-100 flex items-center justify-center">
                  <Ic size={22} className="text-[#0f2846]" />
                </div>
                <div className="font-display font-bold text-[#0f2846]">{b.title}</div>
                <div className="text-slate-400 text-sm">{b.sub}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Hero;
